module.exports = __webpack_public_path__ + "img/ermporia_blue-compressed_ocular.744a5538.jpg";